import { useState } from "react";
import { Divider, Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import Drawer from "ui-components/Drawer";
import { getSKULog } from "services/data.internal.service";
import MDTypography from "components/MDTypography";
import DetailTable from "ui-components/tables/DetailTable";
import MDBox from "components/MDBox";

function SKULog({ open, setOpen, logRequest, setLogRequest }) {
  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["sku-log", { logRequest }],
    queryFn: () => getSKULog(logRequest),
    enabled: logRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;

      const renderTimelineItems = item.logs.map(({ id, ...log }) => (
        <TimelineItem key={id} {...log} />
      ));
      setLogs(
        <>
          <MDBox marginBottom="20px">
            <MDTypography variant="h5" color="info">SKU</MDTypography>
            <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
            <div style={{ fontSize: "14px" }}>
              <Grid container>
                <Grid item xs={6}>
                  <b>SKU Code: </b>
                  {item.skuCode}
                </Grid>
                <Grid item xs={6}>
                  <b>Customer Code: </b>
                  {item.customerCode}
                </Grid>
                <Grid item xs={6}>
                  <b>Product Name: </b>
                  {item.descriptions1}
                </Grid>
                <Grid item xs={6}>
                  <b>Category: </b>
                  {item.category}
                </Grid>
                <Grid item xs={6}>
                  <b>Picking Rules: </b>
                  {item.pickingRules}
                </Grid>
                <Grid item xs={6}>
                  <b>Kit Type: </b>
                  {item.kitType}
                </Grid>
              </Grid>
              <MDTypography variant="h5" color="info">Pack Type</MDTypography>
              <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
              {item.packtypes.map((x, index) => (
                <Grid container key={index}>
                  <Grid item xs={4}>
                    <b>Vendor Code: </b>
                    {x.vendorCode}
                  </Grid>
                  <Grid item xs={4}>
                    <b>Pack Type: </b>
                    {x.packType}
                  </Grid>
                  <Grid item xs={4}>
                    <b>Base UOM: </b>
                    {x.baseUOM}
                  </Grid>
                  <Grid item xs={4}>
                    <b>Inner Pack: </b>
                    {x.innerPack}
                  </Grid>
                  <Grid item xs={4}>
                    <b>Case: </b>
                    {x.case}
                  </Grid>
                  <Grid item xs={4}>
                    <b>Pallet: </b>
                    {x.pallet}
                  </Grid>
                  <Grid item xs={4}>
                    <b>Cubic: </b>
                    {x.cubic}
                  </Grid>
                  <Grid item xs={4}>
                    <b>Gross Weight: </b>
                    {x.grossWeight}
                  </Grid>
                  <Grid item xs={4}>
                    <b>Net Weight: </b>
                    {x.netWeight}
                  </Grid>
                </Grid>
              ))}
            </div>
            <MDTypography variant="h5" color="info">Retail Barcode</MDTypography>
            <Divider sx={{ margin: "5px 0 12px 0", background: "#9ebeeb", opacity: "unset" }} />
            <DetailTable
              columns={[
                { label: "Retail Barcode", id: "retailBarcode" },
                { label: "UOM Type", id: "uomType" },
              ]}
              rows={item.barcodes}
            />
          </MDBox>
          {/* <MDBox marginBottom="20px">
            <MDTypography variant="h5">Vendor SKU</MDTypography>
            <Divider sx={{ margin: "5px 0 12px 0", background: "#9ebeeb", opacity: "unset" }} />
            <DetailTable
              columns={[
                { label: "Vendor Code", id: "vendorCode" },
                { label: "Vendor SKU", id: "vendorSKU" },
                { label: "Recv Whse", id: "defRecvWh" },
                { label: "Recv Zone", id: "defRecvZone" },
                { label: "Recv Location", id: "defRecvLocation" },
                { label: "Putaway Whse", id: "defPutawayWh" },
                { label: "Putaway Zone", id: "defPutawayZone" },
                { label: "Putaway Location", id: "defPutawayLocation" },
              ]}
              rows={item.vendorSKUs}
            />
          </MDBox>
          <MDBox marginBottom="20px">
            <MDTypography variant="h5">Pack Type</MDTypography>
            <Divider sx={{ margin: "5px 0 12px 0", background: "#9ebeeb", opacity: "unset" }} />
            <DetailTable
              columns={[
                { label: "Vendor Code", id: "vendorCode" },
                { label: "Pack Type", id: "packType" },
                { label: "Base UOM", id: "baseUOM" },
                { label: "UPM Case", id: "upmCase" },
                { label: "UPM Pallet", id: "upmPallet" },
                { label: "UPM Gross Weight", id: "upmGrossWeight" },
                { label: "UPM Cubic", id: "upmCubic" },
                { label: "Pallet Type", id: "palletType" },
              ]}
              rows={item.packtypes}
            />
          </MDBox> */}
          <MDBox marginBottom="20px">
            {/* <MDTypography variant="h5" color="info">Retail Barcode</MDTypography>
            <Divider sx={{ margin: "5px 0 12px 0", background: "#9ebeeb", opacity: "unset" }} />
            <DetailTable
              columns={[
                { label: "Retail Barcode", id: "retailBarcode" },
                { label: "UOM Type", id: "uomType" },
              ]}
              rows={item.barcodes}
            /> */}
          </MDBox>

          <TimelineList title="Logs">{renderTimelineItems}</TimelineList>
        </>
      );
      //setPonum(null);
    },
    //onError,
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setLogRequest(null);
  };

  return (
    <Drawer open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default SKULog;
